export default "__VITE_ASSET__BV_X5I5L__"